import { useAxios } from "@/app/providers/AxiosProvider";
import { useMutation, useQueryClient } from "@tanstack/react-query";

/** Contact fields accepted by the API; `tags` is a list of tag names. */
export type ContactPayload = Record<string, unknown> & { tags?: string[] };

export default function useCreateContact() {
  const api = useAxios();
  const client = useQueryClient();

  return useMutation({
    mutationFn: (contact: ContactPayload) => {
      return api.post(`/contacts`, contact);
    },
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ["contacts"] });
      client.invalidateQueries({ queryKey: ["contacts-by-company"] });
      client.invalidateQueries({ queryKey: ["contact-names"] });
      client.invalidateQueries({ queryKey: ["contact-companies"] });
    },
  });
}
